import React, { useState } from "react";
import Header from "./Header/Header";
import Hero from "./Hero/Hero";
import ValueProps from "./ValueProps/ValueProps";
import Categories from "./Categories/Categories";
import Partners from "./Partners/Partners";
import PopularProducts from "./PopularProducts/PopularProducts";
import Services from "./Services/Services";
import HowItWorks from "./HowItWorks/HowItWorks";
import FAQ from "./FAQ/FAQ";
import Franchise from "./Franchise/Franchise";
import DownloadApp from "./DownloadApp/DownloadApp";
import Footer from "./Footer/Footer";

export default function HomePages() {
  const [cartCount, setCartCount] = useState(0);

  const handleAddToCart = () => {
    setCartCount((prev) => prev + 1);
  };

  return (
    <div className="appContainer">
      <main className="mainContent">
        <Hero code="TYRE" />
        <ValueProps />
        <Categories code="TYRE" />
        <Partners code="TYRE" />
        <PopularProducts code="TYRE" entityType="POPULAR" />
        <Services />
        <HowItWorks />
        <FAQ />
        <Franchise />
        <DownloadApp />
      </main>
    </div>
  );
}
